export const TOS_URL = "https://www.upsquad.com/terms-conditions-privacy-policy";
export const PRIVACY_URL = "https://www.upsquad.com/terms-conditions-privacy-policy";
export const GOOGLE_PLAY_URL = "https://play.google.com/store/apps/details?id=co.upsquad.app";
export const APP_STORE_URL = "https://apps.apple.com/in/app/upsquad/id1633234386";
